import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { LocalContentService } from '../../services/local-content/local-content.service'

@Component({
  selector: 'app-content-image',
  templateUrl: './content-image.component.html',
  styleUrls: ['./content-image.component.scss'],
})
export class ContentImageComponent implements OnInit {

  @Input() pageRef: string = null;
  @Input() imageIndex = 0;


  constructor(private localContentService: LocalContentService) { }

  public content = "#";
  public loaded = false;
  public streamMedia = false;

  ngOnInit() {
    if (this.pageRef) {
      let ext = this.localContentService.getMediaType(this.pageRef, this.imageIndex);
      this.streamMedia = (ext == 'mp4');
      if (this.streamMedia) { //using a media stream
        this.content = this.localContentService.getMediaStreamURL(this.pageRef, this.imageIndex);
        this.loaded = true;
      } else //this is a image so we might have a cache at various levels
        this.localContentService.getStaticResourceAsURL(this.pageRef, this.imageIndex).subscribe((res: any) => {
          this.content = res;
          this.loaded = true;
        });
    }
  }

}
